import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "animate.css/animate.min.css";
import { WOW } from "wowjs";
import "../../src/index.css";
import Preloader from "../components/Preloader";
import ScrollToTop from "../components/ScrollToTop";
import LoadTop from "../components/ScrollToTop/LoadTop";
import { Toaster } from "react-hot-toast";

import {
  About,
  Blog,
  BlogDetails,
  BlogSidebar,
  BlogTwo,
  Cart,
  Checkout,
  Contact,
  CourseDetails,
  CourseOne,
  CourseTwo,
  Error,
  Event,
  EventDetails,
  Faq,
  Home,
  HomeFive,
  HomeFiveOnePage,
  HomeFour,
  HomeFourOnePage,
  HomeOnePage,
  HomeThree,
  HomeThreeOnePage,
  HomeTwo,
  HomeTwoOnePage,
  InstructorRegistration,
  Price,
  Service,
  ServiceDetails,
  ServiceThree,
  ServiceTwo,
  Shop,
  ShopDetails,
  SignIn,
  SignUp,
  StudentRegistration,
  Teacher,
  TeacherDetails,
  Testimonial,
  Mission,
  Partners,
  Leadership,
  News,
  NewsDetails,
  Education,
  Jobs,
  JobApply,
  Membership,
  StudentLogin,
  StudentRegister,
  MembershipApplication,
  Members,
  MemberProfile,
  ChangePassword,
  ChangePasswordStd,
  Login,
  DashBoard,
  AddEvents,
  EventsList,
  PendingEvents,
  AddGallery,
  PendingGallery,
  GalleryList,
  AddNews,
  PendingNews,
  NewsList,
  MemberList,
  CreateMember,
  PendingMembers,
  ApprovedMembers,
  RejectedMembers,
  DesignationList,
  AddDesignations,
  AddPhotoSlogan,
  Subscribers,
  SendAndSchedule,
  Templates,
  Report,
  Groups,
  AddCategory,
  GalleryListing,
  GalleryDetails,
  AddAdminUser,
  UserList,
  AddJobs,
  JobsList,
  EmailGroups,
  AppliedJobs,
  EmailTemplates,
  EmailSendAndSchedule,
  SmsTemplates,
  SmsSendAndSchedule,
  MembersMain,
  MemberProfileCard,
  EditJob,
  EditNews,
  LeadershipRoleManager,
  EditEvent,
  EditGallery,
  EditMember,
  MemberDetail,
  NewsDetailsAdmin,
  EventDetailsAdmin,
  MaintainerLogin,
  AddDegree,
  AddEdducation,
  EducationList,
  AddMember,
  Aqua2026,
  StudentList,
  ApprovedStudenList,
  ExpiredStudentList,
  PendingStudentsList,
  EditStudent,
  AddStudent,
  SAPEventRegister,
  SapWasEvents,
  Aqua2026V2,
  SapAquaEvents,
  TermsCondition,
  RefundPolicy,
  PrivacyPolicy,
  Programs,
  Announcement,
} from "../pages";
import { AuthProvider } from "../context/AdminAuthContext";
import { ProtectedRoute } from "../routes/ProtectedRoutes";
import SmsGroups from "../pages/admin/messages/SmsGroups";
import { PublicRoute } from "../routes/PublicRoutes";
import { StudentProtectedRoute } from "../routes/StudentProtectedRoute";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 500);
  }, []);

  useEffect(() => {
    new WOW({ live: false, animateClass: "animate__animated" }).init();
  }, [location]);

  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="bottom-right" reverseOrder={false} />
        {isLoading && <Preloader />}
        <ScrollToTop />
        <LoadTop />

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/announcement" element={<Announcement />} />
          <Route path="/terms-conditions" element={<TermsCondition />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/aqua-india-2026" element={<Aqua2026 />} />
          {/* <Route path="/aqua-india-2026-v2" element={<Aqua2026V2 />} /> */}
          <Route path="/home-one-page" element={<HomeOnePage />} />
          <Route path="/home-2" element={<HomeTwo />} />
          <Route path="/home-2-one-page" element={<HomeTwoOnePage />} />
          <Route path="/home-3" element={<HomeThree />} />
          <Route path="/home-3-one-page" element={<HomeThreeOnePage />} />
          <Route path="/home-4" element={<HomeFour />} />
          <Route path="/home-4-one-page" element={<HomeFourOnePage />} />
          <Route path="/home-5" element={<HomeFive />} />
          <Route path="/home-5-one-page" element={<HomeFiveOnePage />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/course-1" element={<CourseOne />} />
          <Route path="/course-2" element={<CourseTwo />} />
          <Route path="/course-details" element={<CourseDetails />} />
          <Route path="/event" element={<Event />} />
          <Route path="/event-details" element={<EventDetails />} />
          <Route path="/teacher" element={<Teacher />} />
          <Route path="/teacher-details" element={<TeacherDetails />} />
          <Route
            path="/instructor-registration"
            element={<InstructorRegistration />}
          />
          <Route path="/services-1" element={<Service />} />
          <Route path="/services-2" element={<ServiceTwo />} />
          <Route path="/services-3" element={<ServiceThree />} />
          <Route path="/service-details" element={<ServiceDetails />} />
          <Route
            path="/student-profile"
            element={
              <StudentProtectedRoute>
                <StudentRegistration />
              </StudentProtectedRoute>
            }
          />
          <Route path="/testimonial" element={<Testimonial />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/price" element={<Price />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop-details" element={<ShopDetails />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <SignIn />
              </PublicRoute>
            }
          />
          <Route path="/blog-1" element={<Blog />} />
          <Route path="/blog-2" element={<BlogTwo />} />
          <Route path="/blog-sidebar" element={<BlogSidebar />} />
          <Route path="/blog-details" element={<BlogDetails />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/strategic-partners" element={<Partners />} />
          <Route path="/news" element={<News />} />
          <Route path="/news-details" element={<NewsDetails />} />
          <Route path="/education" element={<Education />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/job-application" element={<JobApply />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/all-members" element={<MembersMain />} />
          <Route
            path="/student-login"
            element={
              <PublicRoute>
                <StudentLogin />
              </PublicRoute>
            }
          />
          <Route path="/sap-event-register" element={<SAPEventRegister />} />
          <Route path="/student-register" element={<StudentRegister />} />
          <Route
            path="/membership-application"
            element={<MembershipApplication />}
          />
          <Route
            path="/maintainer/login"
            element={
              <PublicRoute>
                <MaintainerLogin />
              </PublicRoute>
            }
          />
          <Route path="/gallery" element={<GalleryListing />} />
          <Route path="/gallery-details" element={<GalleryDetails />} />
          <Route path="/member-card-details" element={<MemberProfileCard />} />
          <Route
            path="/members"
            element={
              <ProtectedRoute allowedRole="member">
                <Members />
              </ProtectedRoute>
            }
          />
          <Route
            path="/member-profile"
            element={
              <ProtectedRoute allowedRole="member">
                <MemberProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-password"
            element={
              <ProtectedRoute allowedRole="member">
                <ChangePassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/forget-password"
            element={
              <ProtectedRoute allowedRole="member">
                <ChangePasswordStd />
              </ProtectedRoute>
            }
          />
          {/* Admin Auth Routes */}
          <Route
            path="/admin/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          {/* Admin Dashboard */}
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRole="admin">
                <DashBoard />
              </ProtectedRoute>
            }
          />
          {/* Admin Portal Users Routes */}
          <Route
            path="/admin/users/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Admin Portal Users"
                requiredPermission="edit"
              >
                <AddAdminUser />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Admin Portal Users"
                requiredPermission="view"
              >
                <UserList />
              </ProtectedRoute>
            }
          />
          {/* Jobs Routes */}
          <Route
            path="/admin/jobs/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Jobs"
                requiredPermission="edit"
              >
                <AddJobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/jobs/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Jobs"
                requiredPermission="view"
              >
                <JobsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/jobs/edit-job"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Jobs"
                requiredPermission="edit"
              >
                <EditJob />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/jobs/applied"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Jobs"
                requiredPermission="view"
              >
                <AppliedJobs />
              </ProtectedRoute>
            }
          />
          {/* Gallery Routes */}
          <Route
            path="/admin/gallery/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Gallery"
                requiredPermission="edit"
              >
                <AddGallery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/gallery/edit-gallery/:id"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Gallery"
                requiredPermission="edit"
              >
                <EditGallery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/gallery/pending"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Gallery"
                requiredPermission="view"
              >
                <PendingGallery />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/gallery/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Gallery"
                requiredPermission="view"
              >
                <GalleryList />
              </ProtectedRoute>
            }
          />
          {/* News Routes */}
          <Route
            path="/admin/news/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="News"
                requiredPermission="edit"
              >
                <AddNews />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/news/pending"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="News"
                requiredPermission="view"
              >
                <PendingNews />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/news/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="News"
                requiredPermission="view"
              >
                <NewsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/news/view-details/:id/:title"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="News"
                requiredPermission="view"
              >
                <NewsDetailsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/news/edit-news"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="News"
                requiredPermission="edit"
              >
                <EditNews />
              </ProtectedRoute>
            }
          />
          {/* Events Routes */}
          <Route
            path="/admin/events/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="edit"
              >
                <AddEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/events/pending"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="view"
              >
                <PendingEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/events/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="view"
              >
                <EventsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/events/view-details"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="view"
              >
                <EventDetailsAdmin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/events/category"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="edit"
              >
                <AddCategory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/events/edit-event"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="edit"
              >
                <EditEvent />
              </ProtectedRoute>
            }
          />
          {/* Members Routes */}
          <Route
            path="/admin/members/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Members"
                requiredPermission="view"
              >
                <MemberList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Members"
                requiredPermission="edit"
              >
                <AddMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/pending"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Members"
                requiredPermission="view"
              >
                <PendingMembers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/edit-member/:id"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Members"
                requiredPermission="edit"
              >
                <EditMember />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/detail/:id/:title"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Members"
                requiredPermission="view"
              >
                <MemberDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/approved"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Members"
                requiredPermission="view"
              >
                <ApprovedMembers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/rejected"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Members"
                requiredPermission="view"
              >
                <RejectedMembers />
              </ProtectedRoute>
            }
          />
          {/* Designation Routes */}
          <Route
            path="/admin/members/designation/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Designation List"
                requiredPermission="edit"
              >
                <AddDesignations />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/designation/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Designation List"
                requiredPermission="view"
              >
                <DesignationList />
              </ProtectedRoute>
            }
          />
          {/* Students Module Routes - NEW SECTION */}
          <Route
            path="/admin/members/students/pending"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Students"
                requiredPermission="view"
              >
                <PendingStudentsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/students/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Students"
                requiredPermission="view"
              >
                <StudentList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/students/expired"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Students"
                requiredPermission="view"
              >
                <ExpiredStudentList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/students/approved"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Students"
                requiredPermission="view"
              >
                <ApprovedStudenList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/students/edit/:id"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Students"
                requiredPermission="edit"
              >
                <EditStudent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/members/students/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Students"
                requiredPermission="edit"
              >
                <AddStudent />
              </ProtectedRoute>
            }
          />
          {/* Leadership Role Routes */}
          <Route
            path="/admin/leadership-role"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Leadership Role"
                requiredPermission="view"
              >
                <LeadershipRoleManager />
              </ProtectedRoute>
            }
          />
          {/* Photo Slogan Routes */}
          <Route
            path="/admin/photo-slogan"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Photo Slogan"
                requiredPermission="view"
              >
                <AddPhotoSlogan />
              </ProtectedRoute>
            }
          />
          {/* Newsletter Hub Routes */}
          <Route
            path="/admin/subscribers"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Newsletter Hub"
                requiredPermission="view"
              >
                <Subscribers />
              </ProtectedRoute>
            }
          />
          {/* Communication Routes - WhatsApp */}
          <Route
            path="/admin/communication/whatsapp/groups"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="view"
              >
                <Groups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communication/whatsapp/templates"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="view"
              >
                <Templates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communication/whatsapp/send-schedule"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="edit"
              >
                <SendAndSchedule />
              </ProtectedRoute>
            }
          />
          {/* Communication Routes - Email */}
          <Route
            path="/admin/communication/email/groups"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="view"
              >
                <EmailGroups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communication/email/templates"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="view"
              >
                <EmailTemplates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communication/email/send-schedule"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="edit"
              >
                <EmailSendAndSchedule />
              </ProtectedRoute>
            }
          />
          {/* Communication Routes - SMS */}
          <Route
            path="/admin/communication/sms/groups"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="view"
              >
                <SmsGroups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communication/sms/templates"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="view"
              >
                <SmsTemplates />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/communication/sms/send-schedule"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Communication"
                requiredPermission="edit"
              >
                <SmsSendAndSchedule />
              </ProtectedRoute>
            }
          />
          {/* Education Routes */}
          <Route
            path="/admin/education/add"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Education"
                requiredPermission="edit"
              >
                <AddEdducation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/education/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Education"
                requiredPermission="view"
              >
                <EducationList />
              </ProtectedRoute>
            }
          />
          {/* Degree Routes */}
          <Route
            path="/admin/education/degree"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Degree"
                requiredPermission="view"
              >
                <AddDegree />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/was-sap-events/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="view"
              >
                <SapWasEvents />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/aqua-event-2026/list"
            element={
              <ProtectedRoute
                allowedRole="admin"
                requiredModule="Events"
                requiredPermission="view"
              >
                <SapAquaEvents />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Error />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
